<template>
  <div class="wrap">
    <el-descriptions title="个人信息" v-model="userInfo">
      <el-descriptions-item class="des-item" label="用户名">{{
        userInfo.userName
      }}</el-descriptions-item>
      <el-descriptions-item class="des-item" label="姓名">{{
        userInfo.realName
      }}</el-descriptions-item>
      <el-descriptions-item
        class="des-item"
        :label="'所属' + shopOrStudioTag"
        >{{ userInfo.shopName }}</el-descriptions-item
      >
      <el-descriptions-item class="des-item" :label="shopOrStudioTag + '身份'">
        <el-tag size="small">{{
          shopOrStudioTag === "工作室" && userInfo.userType === "店主"
            ? "主持人"
            : shopOrStudioTag === "工作室" && userInfo.userType === "店员"
            ? "成员"
            : userInfo.userType
        }}</el-tag>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import api from "@/assets/js/api";
import store from "@/store/index";
export default {
  data() {
    return {
      userInfo: {
        userName: "",
        realName: "",
        shopName: "",
        userType: "",
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {
    shopOrStudioTag: () => {
      return store.getters["user/shopOrStudioTag"];
    },
  },
  methods: {
    /*获取店铺信息*/
    async getUserInfo() {
      let userId = this.$store.state.user.userInfo.userId;
      const userInfoResult = await this.$axios.post(
        api.info.getUserInfo + "?userId=" + userId
      );
      if (userInfoResult.valid) {
        this.userInfo = userInfoResult.result;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  padding: 20px;
  background: #fff;
}
.info-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  /*background-color: #fff;*/
  padding: 20px;
  margin-bottom: 20px;
}

.shop-logo {
  height: 20px;
}

::v-deep .el-descriptions-item {
  display: block;
  padding: 10px;
}

.des-item {
  padding: 10px;
}
</style>
